// extracted by mini-css-extract-plugin
export default {"editable":"OneLine_editable__4nccZ"};